module.exports = __webpack_public_path__ + "img/4-4.b2f7f57c.png";